import { useLocation } from "react-router-dom";

import { SidebarTrigger, useSidebar } from "~/components/ui/sidebar";
import { useProfileStore } from "~/store/profileStore";

export function TopBar() {
  const { state } = useSidebar();
  const isCollapsed = state === "collapsed";
  const { role } = useProfileStore();
  const location = useLocation();

  // Get current page title based on route
  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes("sales-notes")) return "Notas de Venta";
    if (path.includes("clients")) return "Clientes";
    if (path === "/") return "Inicio";
    return "Aliace";
  };

  // Check if user is a seller on mobile
  const isMobileSeller = role === "seller";

  return (
    <div
      className={`fixed left-0 right-0 top-0 z-20 flex h-16 items-center justify-between border-b border-gray-200 bg-white px-4 shadow-sm transition-all duration-200 dark:border-gray-700 dark:bg-gray-800 md:px-6 ${
        !isMobileSeller && !isCollapsed
          ? "md:ml-[var(--sidebar-width)]"
          : "md:ml-0"
      }`}
    >
      <div className="flex items-center gap-2">
        {/* Only show sidebar trigger on non-mobile or non-seller views */}
        {(!isMobileSeller || window.innerWidth >= 768) && <SidebarTrigger />}

        {/* Show logo and title on mobile for sellers */}
        {isMobileSeller && (
          <div className="flex items-center">
            <img src="/aliace-logo.jpg" alt="Aliace" className="mr-2 h-8 w-8" />
            <h1 className="text-lg font-semibold">{getPageTitle()}</h1>
          </div>
        )}
      </div>

      <div className="flex items-center gap-3">
        {/* Notification bell - temporarily hidden
        <Button size="icon" variant="ghost" className="relative">
          <Bell className="h-5 w-5" />
          <span className="absolute -top-1 -right-1 h-4 w-4 rounded-full bg-red-500 flex items-center justify-center text-[10px] text-white">
            3
          </span>
        </Button>
        */}
      </div>
    </div>
  );
}
